<template>
    <BasicTile
        class="w-100 pa-4 pa-md-8 background-tile-big payout_option_denominations_template">
        <v-row no-gutters>
            <v-col cols="12" md="4">
                <span class="heading">
                    <slot name="payout-name"></slot>
                </span>
            </v-col>
        </v-row>
        <v-row no-gutters class="mt-8 d-flex flex-column-reverse flex-md-row flex-column">
            <v-col cols="12" md="4" class="mt-8 mt-md-0">
                <slot name="payout-denomination-details"></slot>
            </v-col>
            <v-col cols="1"></v-col>
            <v-col cols="12" md="7">
                <div class="subheading">
                    Select withdrawal amount
                </div>
                <div>
                    <slot name="payout-denominations"></slot>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <Disclaimer>
                    <slot name="disclaimer"></slot>
                </Disclaimer>
            </v-col>
        </v-row>
    </BasicTile>
</template>



<script setup>

import BasicTile from '@/components/Tiles/Basic-Tile.vue';
import Disclaimer from '@/components/Common/Disclaimer.vue';

</script>